<template>
    <div class="d-flex align-items-center">
        <IconComp
            v-if="showIcon"
            :icon="mimetypeIconmap.get(value) ?? 'fa-file'"
            :title="value"
            class="me-2"
        />
        <span v-if="showText">{{ value }}</span>
    </div>
</template>

<script setup lang="ts">
import { IconComp } from '@/components';

const props = withDefaults(
    defineProps<{
        /**
         * The mimetype to display
         */
        value: string;

        /**
         * If we should show the icon or not
         * @default true
         */
        showIcon?: boolean;

        /**
         * If we should show the text or not
         * @default true
         */
        showText?: boolean;
    }>(),
    {
        showIcon: true,
        showText: true,
    },
);

const mimetypeIconmap = new Map<string, string>([
    ['image', 'fa-file-image'],
    ['audio', 'fa-file-audio'],
    ['video', 'fa-file-video'],
    ['application/pdf', 'fa-file-pdf'],
    ['application/msword', 'fa-file-word'],
    ['application/vnd.ms-word', 'fa-file-word'],
    ['application/vnd.oasis.opendocument.text', 'fa-file-word'],
    ['application/vnd.openxmlformats-officedocument.wordprocessingml', 'fa-file-word'],
    ['application/vnd.ms-excel', 'fa-file-excel'],
    ['application/vnd.openxmlformats-officedocument.spreadsheetml', 'fa-file-excel'],
    ['application/vnd.oasis.opendocument.spreadsheet', 'fa-file-excel'],
    ['application/vnd.ms-powerpoint', 'fa-file-powerpoint'],
    ['application/vnd.openxmlformats-officedocument.presentationml', 'fa-file-powerpoint'],
    ['application/vnd.oasis.opendocument.presentation', 'fa-file-powerpoint'],
    ['text/plain', 'fa-file-text'],
    ['text/html', 'fa-file-code'],
    ['application/json', 'fa-file-code'],
    ['application/gzip', 'fa-file-archive'],
    ['application/zip', 'fa-file-archive'],

    ['text/csv', 'fa-file-csv'],
    ['image/png', 'fa-file-png'],
    ['image/jpeg', 'fa-file-jpg'],
    ['image/gif', 'fa-file-gif'],
    ['image/svg+xml', 'fa-file-svg'],
]);
</script>
